// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StartScreen_container__6PcNS {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 16px;
  gap: 32px;
}

.StartScreen_stack0__OaHaF {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.StartScreen_stack8__wu1z6 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.StartScreen_small__bZDIk {
  font-size: var(--font-size-24);
}

.StartScreen_greySmall__JSXUq {
  color: #757575;
  font-size: var(--font-size-24);
}

.StartScreen_languageButtons__xvv5u {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.StartScreen_languageButton__UrcmO {
  font-size: var(--font-size-24);
}

.StartScreen_languageButtonActive__5z-in {
  background-color: #757575;
}

.StartScreen_divider__qsGAC {
  width: 100%;
  max-width: 56px;
  height: 6px;
  background-color: #757575;
  margin: 0 auto;
}

.StartScreen_settingButton__T3-L7 {
  width: auto;
  margin: 0 auto;
  font-size: var(--font-size-24);
  opacity: 0.6;
}

.StartScreen_settingButton__T3-L7:before {
  content: " ";
  display: inline-block;
  width: 32px;
}

.StartScreen_settingButtonActive__22CTj {
  opacity: 1;
}

.StartScreen_settingButtonActive__22CTj:before {
  content: "✓";
}
`, "",{"version":3,"sources":["webpack://./src/StartScreen.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd","sourcesContent":[".container {\n  max-width: 600px;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  padding: 16px;\n  gap: 32px;\n}\n\n.stack0 {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.stack8 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.small {\n  font-size: var(--font-size-24);\n}\n\n.greySmall {\n  color: #757575;\n  font-size: var(--font-size-24);\n}\n\n.languageButtons {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.languageButton {\n  font-size: var(--font-size-24);\n}\n\n.languageButtonActive {\n  background-color: #757575;\n}\n\n.divider {\n  width: 100%;\n  max-width: 56px;\n  height: 6px;\n  background-color: #757575;\n  margin: 0 auto;\n}\n\n.settingButton {\n  width: auto;\n  margin: 0 auto;\n  font-size: var(--font-size-24);\n  opacity: 0.6;\n}\n\n.settingButton:before {\n  content: \" \";\n  display: inline-block;\n  width: 32px;\n}\n\n.settingButtonActive {\n  opacity: 1;\n}\n\n.settingButtonActive:before {\n  content: \"✓\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StartScreen_container__6PcNS`,
	"stack0": `StartScreen_stack0__OaHaF`,
	"stack8": `StartScreen_stack8__wu1z6`,
	"small": `StartScreen_small__bZDIk`,
	"greySmall": `StartScreen_greySmall__JSXUq`,
	"languageButtons": `StartScreen_languageButtons__xvv5u`,
	"languageButton": `StartScreen_languageButton__UrcmO`,
	"languageButtonActive": `StartScreen_languageButtonActive__5z-in`,
	"divider": `StartScreen_divider__qsGAC`,
	"settingButton": `StartScreen_settingButton__T3-L7`,
	"settingButtonActive": `StartScreen_settingButtonActive__22CTj`
};
export default ___CSS_LOADER_EXPORT___;
